import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../firebase";

function Style() {
  const { id } = useParams();
  const [serviceData, setServiceData] = useState(null);
  const [similarHairstyles, setSimilarHairstyles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchServiceData = async () => {
      try {
        console.log("Fetching service data for ID:", id);

        const docRef = collection(firestore, "services");
        const docSnapshot = await getDocs(docRef);

        docSnapshot.forEach((doc) => {
          if (doc.id === id) {
            setServiceData(doc.data());
            console.log("Service data fetched successfully");
          }
        });

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching service data:", error);
        setIsLoading(false);
      }
    };
    
    const fetchSimilarHairstyles = async () => {
      try {
        console.log("Fetching similar for ID:", id);
        const q = query(
          collection(firestore, "services"),
          where("tags", "array-contains-any", serviceData.tags)
        );
        const querySnapshot = await getDocs(q);

        // Filter out the current hairstyle
        const similarHairstyles = querySnapshot.docs
          .filter((doc) => doc.id !== id)
          .map((doc) => doc.data());

        // Set similar hairstyles state
        setSimilarHairstyles(similarHairstyles);
      } catch (error) {
        console.error("Error fetching similar hairstyles:", error);
      }
    };

    if (serviceData) {
      fetchSimilarHairstyles();
    }

    fetchServiceData();
  }, [serviceData, id]);

  return (
    <main id="service-details">
      <div className="bg"></div>
      <section className="flex justify-center">
        <section className="details">
          {isLoading ? (
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#cd5c5e"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          ) : serviceData ? (
            <>
              <div className="flex align-center justify-center">
                <div className="text">
                  <h2>{serviceData.name}</h2>
                  <p>{serviceData.description}</p>
                </div>
                <div className="img">
                  <img src={serviceData.imgUrl[0]} alt={serviceData.name} />
                </div>
              </div>
              <div className="slider"></div>
              <a href="." className="button button-primary">
                Book Now
              </a>
            </>
          ) : (
            <p>Service not found</p>
          )}
          <h3>Reviews</h3>
          {isLoading ? (
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#cd5c5e"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          ) : (
            <></>
          )}
        </section>
        <aside>
          <h3>Others like this</h3>
          {isLoading ? (
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#cd5c5e"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          ) : (
            <ul>
              {similarHairstyles.slice(0, 3).map((hairstyle, index) => (
                <li key={index}>{hairstyle.name}</li>
              ))}
            </ul>
          )}
        </aside>
      </section>
    </main>
  );
}

export default Style;
